import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { DropdownType } from "../enums";
import { DropdownList, IMultiRowList, ISingleRowList } from "./DropdownList";

export interface IAdvancedDropdown {
    selectedValue: number | string;
    attributes: IMultiRowList[] | ISingleRowList[];
    text?: string | number | string[] | number[];
    multiLineText?: boolean;
    hideTextOnOpen?: boolean;
    buttonAsRow?: boolean;
    type: DropdownType;
    title: string;
    alwaysOpen: boolean;
    closeOnSubmit: boolean;
    clicked: (attribute: IMultiRowList | ISingleRowList) => void;
    chevronClass?: string[];
    onToggle?: (expanded: boolean) => void;
}

export const AdvancedDropdown = (props: IAdvancedDropdown): JSX.Element => {
    const [expanded, setExpanded] = useState<boolean>(props.alwaysOpen);
    const [attributes, setAttributes] = useState<IMultiRowList[] | ISingleRowList[]>(props.attributes);

    const myRef = useRef<HTMLDivElement>();

    useEffect(() => {
        document.addEventListener("mousedown", (e) => handleClick(e));
        return document.removeEventListener("mousedown", (e) => handleClick(e));
    }, []);

    useEffect(() => {
        props.onToggle && props.onToggle(expanded);
    }, [expanded]);

    useEffect(() => {
        setAttributes(props.attributes);
    }, [props.attributes]);

    const handleClick = (e) =>
        myRef.current && !props.alwaysOpen && !myRef.current.contains(e.target) && setExpanded(false);

    const clicked = (attribute: IMultiRowList | ISingleRowList) => {
        props.clicked(attribute);
        setExpanded(props.alwaysOpen ? true : !props.closeOnSubmit);
    };

    const toggleList = () => setExpanded(props.alwaysOpen ? true : !expanded);

    const Button = () => (
        <div className="button">
            {props.alwaysOpen ? null : (
                <>
                    {props.multiLineText ? (
                        props.text && Array.isArray(props.text) ? (
                            <span title={props.title} className="dropdown-button">
                                {props.text.map((element: string | number) => (
                                    <span key={element.toString()}>{element}</span>
                                ))}
                            </span>
                        ) : (
                            <span title={props.title} className="dropdown-button">
                                {[]}
                            </span>
                        )
                    ) : (
                        <span title={props.title} className="dropdown-button">
                            {props.text || ""}
                        </span>
                    )}
                    {props.chevronClass ? (
                        <div className={"chevron " + (expanded ? props.chevronClass[1] : props.chevronClass[0])} />
                    ) : null}
                </>
            )}
        </div>
    );

    const RowButton = () => (
        <div className="button row">
            {props.alwaysOpen ? null : (
                <>
                    {props.selectedValue
                        ? (props.attributes as IMultiRowList[]).map((attribute: IMultiRowList, i: number) =>
                              attribute.value === props.selectedValue && attribute.labelRows ? (
                                  <span
                                      key={attribute.value.toString() + i}
                                      onClick={() => props.clicked(attribute)}
                                      className="listRow"
                                  >
                                      {attribute.labelRows.map((row: string | number, i: number) => (
                                          <span key={row.toString() + i}>{row}</span>
                                      ))}
                                  </span>
                              ) : null
                          )
                        : null}

                    {props.chevronClass ? (
                        <div className={"chevron " + (expanded ? props.chevronClass[1] : props.chevronClass[0])} />
                    ) : null}
                </>
            )}
        </div>
    );

    return (
        <>
            <div className="advanced-dropdown" ref={myRef} onClick={toggleList}>
                {props.hideTextOnOpen && expanded ? null : props.buttonAsRow ? <RowButton /> : <Button />}
                {/* {props.hideTextOnOpen && expanded ? null : <Button />} */}
                {expanded && (
                    <DropdownList
                        type={props.type}
                        clicked={clicked}
                        attributes={attributes}
                        selectedValue={props.selectedValue}
                    />
                )}
            </div>
        </>
    );
};
